import React from 'react';
import { motion } from 'framer-motion';
import { Search, Sparkles, Wand2, Map, Crown, TrendingUp } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcBenefits() {
  const benefits = [{
    icon: Search,
    title: 'Identifici credințele care te țin pe loc',
    desc: 'Scoți la lumină exact ce gânduri repetitive te sabotează financiar și personal. Conștientizarea e primul pas al schimbării.'
  }, {
    icon: Wand2,
    title: 'Le elimini și le înlocuiești',
    desc: 'Primești tehnici concrete prin care eliberezi credințele vechi și le înlocuiești cu o mentalitate care te susține.'
  }, {
    icon: Sparkles,
    title: 'Descoperi afirmații puternice',
    desc: 'Afirmații testate, nu formule generice. Le practici zilnic și simți cum modul tău de a gândi se schimbă.'
  }, {
    icon: Map,
    title: 'Îți creezi harta comorilor',
    desc: 'Un instrument vizual și practic care îți clarifică direcția și te ghidează spre ce îți dorești cu adevărat.'
  }, {
    icon: Crown,
    title: 'Înțelegi sensul real al prosperității',
    desc: 'Sănătate, relații, liniște, libertate — toate din plin. Aici înțelegi prosperitatea la un nivel profund.'
  }, {
    icon: TrendingUp,
    title: 'Vezi schimbări concrete în viața ta',
    desc: 'Pe măsură ce mentalitatea se schimbă, oportunitățile apar, banii vin mai ușor și tu ești pregătită să le primești.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-844">
      <div className="max-w-7xl mx-auto px-6" data-id="element-845">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-846" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-847">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-848">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-849">
                  <Icon className="w-8 h-8" data-id="element-850" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-851">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-852">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-853">
          <CTAButton data-id="element-854" />
        </motion.div>
      </div>
    </section>;
}